import React from 'react'

export const InfoBlackSvg = ({...props}) => {
    return (
        <svg {...props} width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11.5" cy="11.5" r="11.5" fill="#040503" />
            <path d="M10.1667 9.96266H12.8333V18H10.1667V9.96266ZM10.4333 7.76902C10.1444 7.44537 10 7.06178 10 6.61826C10 6.17474 10.1444 5.79714 10.4333 5.48548C10.7333 5.16183 11.0889 5 11.5 5C11.9111 5 12.2611 5.16183 12.55 5.48548C12.85 5.79714 13 6.17474 13 6.61826C13 7.06178 12.85 7.44537 12.55 7.76902C12.2611 8.08068 11.9111 8.23651 11.5 8.23651C11.0889 8.23651 10.7333 8.08068 10.4333 7.76902Z" fill="white" />
        </svg>

    )
}
